export const SUPPORTS_SET = typeof Set !== "undefined";
